import script from "./AuthorityListingPurchase.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorityListingPurchase.vue?vue&type=script&setup=true&lang=js"

import "./AuthorityListingPurchase.vue?vue&type=style&index=0&id=f94bb3f4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f94bb3f4"]])

export default __exports__